import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const fileTagsState = (state: RootState) => state.scene.settings.fileTags;

export const getFileTags = createSelector(fileTagsState, ({ fileTags }) => fileTags);

export const getFileTagsMap = createSelector(
  fileTagsState,
  ({ fileTags }) => new Map(fileTags.map((tag) => [tag.id, tag]))
);

export const isLoading = createSelector(fileTagsState, ({ loading }) => loading);
export const getTotalFileTags = createSelector(fileTagsState, ({ total }) => total);
export const getViewState = createSelector(fileTagsState, ({ viewState }) => viewState);
